// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"631":"contact","893":"products"}[chunkId] + "." + {"631":"db69ab74","893":"4c7288c6"}[chunkId] + ".css";
};